import * as React from "react";
import { buildClasses } from "../utils/classes";
import "./Panel.scss";

export interface PanelProps {
  children?: React.ReactNode;
  id?: string;
  fullWidth?: boolean;
  withShadow?: boolean;
}

export default function Panel({ children, id, fullWidth, withShadow }: PanelProps) {
  return (
    <div className={buildClasses({ "with-shadow": withShadow }, "react-panel")} id={id}>
      <div className={buildClasses({ fullWidth }, "react-panel-content")}>{children}</div>
    </div>
  );
}
